import { ContainerSize } from "@deliverr/storage-client";

export const ContainerSizeToDisplayValue: Record<ContainerSize, string> = {
  [ContainerSize.GENERAL_20FT]: "20",
  [ContainerSize.GENERAL_40FT]: "40",
};
